import { render } from "./UiTabbar.vue?vue&type=template&id=d35ed784&ts=true"
import script from "./UiTabbar.vue?vue&type=script&lang=ts"
export * from "./UiTabbar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__